export class OfficeEquipmentBrandInput {
    public name: string = '';
}
